module.exports = "https://www.gc-pro.gnp.com.mx/85b58f566d31ff2dc04618d6469b6972.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/otp/4.png
// module id = 1039
// module chunks = 0 1